module.exports = __webpack_public_path__ + "static/img/admin-role.2cd32258.png";